import $ from 'cash-dom';
import { imageNotFound } from '@/core/responsive/image/helpers/image-not-found.constant';

function errorHandler(el:HTMLElement, classNamesArray:string[] = []) {
    el.setAttribute('src', imageNotFound);
    el.removeAttribute('srcset');

    $(el.parentNode).children('source').remove();

    classNamesArray.forEach((className: string) => {
        if (className) {
            el.classList.add(className);
        }
    });
}

export default errorHandler;
